import * as Toast from "~/lib/Toast";
import useBusinessPostApi from "~/lib/useBusinessPostApi";
import TextArea from "~/components/TextArea";
import {useEffect, useState} from "react";
import {useDebounce} from "@uidotdev/usehooks";

export const BanBanner = ({banSettings}) => {
    const {ban, banMessage, setBanMessage, isUnbanning, doUnban} = banSettings;
    return (
        <>
            {!!ban && (
                <div className="mt-4">
                    <div className="flex items-center justify-between bg-red-100 text-red-700 rounded-lg p-4">
                        <div>
                            Client is banned.

                            <div className="mt-2">
                                Banning is done by email address and web browser.
                            </div>
                        </div>
                        <button
                            type="button"
                            className="btn-red-pill-sm uppercase ml-2"
                            onClick={doUnban}
                        >
                            {isUnbanning ? 'Unbanning...' : 'Unban'}
                        </button>
                    </div>

                    <TextArea
                        label="Ban Message (Shown to Client)"
                        value={banMessage}
                        onChange={setBanMessage}
                        className="mt-4"
                        placeholder="You are not able to submit this at this time"
                    />
                </div>
            )}
        </>
    )
}

const useBanClient = ({refetchClientDetails, client, ban}) => {
    const {save : saveBan, isSaving : isBanning} = useBusinessPostApi(`/clients/ban`);
    const {save : saveUnban, isSaving : isUnbanning} = useBusinessPostApi(`/clients/unban`);

    const [banMessage, setBanMessage] = useState('')

    useEffect(() => {
        if (ban?.message) {
            setBanMessage(ban?.message)
        }
    }, [ban?.message]);

    function doBan()
    {
        if (confirm('Are you sure you want to ban this client from booking/forms?')) {
            saveBan({
                email: client?.email,
            }).then((result) => {
                Toast.success('Successfully banned client');
                refetchClientDetails();
            })
        }
    }

    function updateBan(message)
    {
        saveBan({
            email: client?.email,
            message: message,
        })
    }

    function doUnban()
    {
        saveUnban({
            email: client?.email,
        }).then((result) => {
            Toast.success('Successfully unbanned client');
            refetchClientDetails();
        })
    }

    const debouncedBanMessage = useDebounce(banMessage, 500);
    useEffect(() => {
        updateBan(debouncedBanMessage);
    }, [debouncedBanMessage]);

    return {
        doBan,
        doUnban,
        isBanning,
        BanBanner,
        banComponentSettings: {ban, banMessage, setBanMessage, isUnbanning, doUnban}
    }
}

export default useBanClient;
